<template>
  <!-- 上传记录 - 上传中 author: zhangxiaofeng-->
  <div class="upload-history width-fullh height-full">
    <div class="upload-table-wrapper" :class="{pagination: totalCount > pageSize}" id="upload-table-wrapper">
      <!--<simple-table :height="tableHeight">-->
        <!--<template slot="header">-->
          <!--<thead class="has-gutter">-->
          <!--<tr class>-->
            <!--<th class="font-left" width="20">-->
              <!--<i class="file-icons-null"></i>-->
            <!--</th>-->
            <!--<th class="font-left" width="100">名称</th>-->
            <!--<th class="font-center" width="80">文件类型</th>-->
            <!--<th class="font-center" width="80">上传时间</th>-->
            <!--<th class="font-center" width="80">文件大小</th>-->
            <!--<th class="font-center" width="80">上传状态</th>-->
          <!--</tr>-->
          <!--</thead>-->
        <!--</template>-->
        <!--<template slot="body" v-if="dataList.length>0">-->
          <!--<thead class="ui-table_head">-->
          <!--<tr height="42">-->
            <!--<th class="font-left" width="20"></th>-->
            <!--<th class="font-left" width="100">名称</th>-->
            <!--<th class="font-center" width="80">文件类型</th>-->
            <!--<th class="font-center" width="80">上传时间</th>-->
            <!--<th class="font-center" width="80">文件大小</th>-->
            <!--<th class="font-center" width="80">上传状态</th>-->
          <!--</tr>-->
          <!--</thead>-->
          <!--<tbody id="projectContent">-->
          <!--<tr v-for="(i, index) in dataList" :key="index">-->
            <!--<td class="font-left" width="20">-->
              <!--<i-->
                <!--:class="['file-icons', 'icon_' + i.suffix, 'icon_' + i.projectType, i.folder ? 'folder': '']"-->
              <!--&gt;</i>-->
            <!--</td>-->
            <!--<td class="font-left filename-box" width="100" :title="i.fileName">-->
              <!--{{i.fileName}}-->
              <!--<span class="upload-new" v-if="i.unread==1"></span>-->
            <!--</td>-->
            <!--<td class="font-center" width="80">{{i.projectType}}</td>-->
            <!--<td class="font-center" width="80">{{i.beginTime | formatDate}}</td>-->
            <!--<td class="font-center" width="80">{{i.fileSize}}</td>-->
            <!--<td class="font-center" width="80">{{i.statusName}}</td>-->
          <!--</tr>-->
          <!--</tbody>-->
        <!--</template>-->
        <!--<div slot="body" v-else class="empty-box">-->
          <!--<img src="@/assets/images/default_empty.png" />-->
          <!--<p>还没有{{uploadTypeList.indexOf(0)>-1?"工程":uploadTypeList.indexOf(2)>-1?"清单":"组价"}}上传记录</p>-->
        <!--</div>-->
      <!--</simple-table>-->
      <div class="ui-fixed tree-table fit flex flex-column table-medium table-beyond-hiding" style="height: calc(100% - 8px);" id="tree-table" v-loading="loading">
        <div class="header-wrapper" ref="headerWrapper">
          <div class="table-header flex flex-row" style="width: 100%;">
            <div class="header-item is-leaf" style="width: 80px;"></div>
            <div class="header-item is-leaf flex-1">名称</div>
            <div class="header-item is-leaf" style="width: 100px;">文件类型</div>
            <div class="header-item is-leaf" style="width: 100px;">上传时间</div>
            <div class="header-item is-leaf" style="width: 100px;">文件大小</div>
            <div class="header-item is-leaf" style="width: 100px;">上传状态</div>
            <div class="has-gutter" v-if="scrollY"></div>
          </div>
        </div>
        <div class="body-wrapper flex-1" :class="{'relative': dataList.length === 0}" style="overflow: auto;" ref="bodyWrapper">
          <ul class="container" :style="{width: tableWidth + 'px'}" ref="containerWrapper" v-if="dataList.length>0">
            <li v-for="(i, index) in dataList" :key="index" class="flex flex-row row row--level-1">
              <div class="cell column_1" style="width: 80px;">
                <i :class="['file-icons', 'icon_' + i.suffix, 'icon_' + i.projectType, i.folder ? 'folder': '']"></i>
              </div>
              <div class="cell column_2  flex-1">
                <div class="name-div" :title="i.fileName">
                  {{i.fileName}}
                  <span class="upload-new" v-if="i.unread==1"></span>
                </div>
              </div>
              <div class="cell column_3" style="width: 100px;">{{i.projectType}}</div>
              <div class="cell column_3" style="width: 100px;">{{i.beginTime | formatDate}}</div>
              <div class="cell column_3" style="width: 100px;">{{i.fileSize}}</div>
              <div class="cell column_3" style="width: 100px;">{{i.statusName}}</div>
            </li>
          </ul>
          <div class="absolute text-align-center" style="top: 50%;left: 50%;transform: translate(-50%,-50%);" v-else>
            <div class="text-align-center color-white" style="width:56px;height:56px;line-height:56px;background:rgba(33,37,48,0.15);border-radius: 50%;margin: 0 auto;">
              <i class="r2-icon-action_description" style="font-size: 30px;"></i>
            </div>
            <div class="text-align-center font-16 color-999" style="font-size:14px;margin-top: 12px">
              还没有{{uploadTypeList.indexOf(0)>-1?"工程":uploadTypeList.indexOf(2)>-1?"清单":"组价"}}上传记录
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="page-box" v-show="totalCount>pageSize">
      <w-pagination
        @current-change="handleCurrentChange"
        @size-change="handlePageSizeChange"
        :page-sizes="[20, 50, 100, 200]"
        background
        layout="total, prev, pager, next, jumper, sizes"
        :page-size="pageSize"
        :total="totalCount"
      ></w-pagination>
    </div>
  </div>
</template>
<style>
.filename-box {
  cursor: default;
}
</style>
<script>
// import { SimpleTable } from '@/components/common'
import UploadHistoryService from '@/assets/service/uploadhistory'
import { formatDate } from '@/assets/utils/Date'
export default {
  data: () => {
    return {
      scrollY: false,
      loading: false,
      // tableHeight: 300,
      dataList: [],
      totalCount: 0,
      pageSize: 20,
      pageNum: 1,
      statusList: [1],
      uploadTypeList: []
    }
  },
  props: {
    module: {
      default: '2,3'
    }
  },
  components: {
    // SimpleTable
  },
  filters: {
    formatDate (value) {
      return formatDate(new Date(value), 'yyyy-MM-dd')
    }
  },
  methods: {
    // setTableHeight() {
    //   let winH = document.documentElement.clientHeight
    //   this.tableHeight = winH - 200
    // },
    // 更改页显示多少
    handlePageSizeChange (index) {
      this.pageSize = index
      this.queryUploadList(this.statusList, this.uploadTypeList)
    },
    // 更改页码
    handleCurrentChange (index) {
      this.pageNum = index
      this.queryUploadList(this.statusList, this.uploadTypeList)
    },
    // 获取请求列表
    queryUploadList () {
      let _self = this
      let tableTypeOne = _self.uploadTypeList[0]
      let params = {
        pageNum: _self.pageNum,
        pageSize: _self.pageSize,
        statusList: _self.statusList,
        uploadTypeList: _self.uploadTypeList
      }
      _self.loading = true
      let apiName = 'queryUploadListBigData'
      if (JSON.stringify(this.uploadTypeList) === '[0,1]') { apiName = 'queryUploadList' }
      UploadHistoryService[apiName](params).then(res => {
        _self.loading = false
        if (_self.uploadTypeList[0] !== tableTypeOne) {
          return
        }
        if (+res.code === 200) {
          _self.dataList = res.data.items
          _self.totalCount = res.data.totalCount
        } else {
          _self.dataList = []
        }
      }).catch(() => {
        _self.loading = false
      })
    }
  },
  watch: {
    $route (to, from) {
      let _self = this
      _self.pageNum = 1
      if (to.path.indexOf('project') > -1) {
        _self.uploadTypeList = [0, 1]
      } else if (to.path.indexOf('list') > -1) {
        _self.uploadTypeList = [2, 3, 4]
      } else {
        _self.uploadTypeList = [5, 6, 7]
      }
      _self.queryUploadList(_self.statusList, _self.uploadTypeList)
    }
  },
  mounted () {
    if (this.$route.path.indexOf('project') > -1) {
      this.uploadTypeList = [0, 1]
    } else if (this.$route.path.indexOf('list') > -1) {
      this.uploadTypeList = [2, 3, 4]
    } else {
      this.uploadTypeList = [5, 6, 7]
    }
    this.queryUploadList(this.statusList, this.uploadTypeList)
    // setTimeout(this.setTableHeight, 200)
    // this.resizeHandle.resize(() => {
    //   this.setTableHeight()
    // })
  },
  updated () {
    let scrollY
    try {
      scrollY = this.$refs.containerWrapper.clientHeight > this.$refs.bodyWrapper.clientHeight
    } catch (e) {
      scrollY = false
    }
    this.scrollY = scrollY
  }
}
</script>
